<template>
  <!-- ------------------------------------- 底部栏 ----------------------------------- -->
  <div class="footer">
    <!-- 导航组 -->
    <div class="nav_block">
      <div class="navigation">
        <!-- 品牌故事 -->
        <div class="brand">
          <p @click="toAbout()">品牌故事</p>
          <p @click="toAir()">AIR</p>
          <!-- <p>GREEN</p> -->
          <p @click="toCare()">CARE</p>
        </div>
        <!-- 2D体验馆 -->
        <div class="brand">
          <p @click="toExper()">2D体验馆</p>
          <p @click="toDete()">服务预约</p>
          <p @click="toInfor()">企业资讯</p>
          <p @click="toSubscribe()">订阅我们</p>
        </div>
        <!-- 联络我们 -->
        <div class="brand">
          <div>联络我们</div>
          <span>400 888 6869</span>
          <a
            href="mailto:support@renaudchina.com"
            target="_blank"
            style="color: #525252"
          >
            <span>support@renaudchina.com</span>
          </a>
          <span>09:00 - 18:00 | Mon - Fri</span>
        </div>
        <!-- 关注我们 -->
        <div class="focus">
          <p>关注我们</p>
          <div class="focus_box">
            <!-- facebook -->
          <!--  <a
              href="https://www.facebook.com/Renaud-Air-China-2139475802801534/"
              target="_blank"
            >
              <img src="../assets/images/icon/facebook.png" alt="" />
            </a> -->
            <!-- Linkedin -->
          <!--  <a
              href="https://www.linkedin.com/company/renaud-air-china/"
              target="_blank"
            >
              <img
                style="margin: 0 20px"
                src="../assets/images/icon/ins.png"
                alt=""
              />
            </a> -->
            <!-- 淘宝 -->
          <!--  <a href="https://www.shop306540905.taobao.com" target="_blank">
              <img src="../assets/images/icon/taobao.png" alt="" />
            </a> -->
          </div>
          <div class="focus_box">
            <!-- 微信 -->
            <el-popover placement="top-start" trigger="hover">
              <div>
                <img
                  class="wechat_code"
                  src="../assets/images/icon/wechat-code.jpg"
                  alt=""
                />
              </div>
              <img
                slot="reference"
                src="../assets/images/icon/wechat.png"
                alt=""
              />
            </el-popover>

            <!-- 微博 -->
           <!-- <a href="http://www.weibo.com/renaudair" target="_blank">
              <img
                style="margin: 0 0 0 20px"
                src="../assets/images/icon/sina.png"
                alt=""
              />
            </a> -->
          </div>
        </div>
        <!-- 支付方式 -->
        <div class="play">
          <p>支付方式</p>
          <div class="play_box">
            <img src="../assets/images/icon/wechat-pay.png" alt="" />
            <img src="../assets/images/icon/alipay.png" alt="" />
          </div>
          <div class="play_box">
            <img src="../assets/images/icon/pocket.png" alt="" />
            <img
              class="play_card"
              src="../assets/images/icon/union.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 导航栏 -->

    <div class="bottom">
      <div>联络我们</div>
      <div>
        400 920 3910 &nbsp;&nbsp;&nbsp;<a style="color: #525252"
          >support@renaudchina.com</a
        >
        &nbsp;&nbsp;&nbsp;09:00 - 18:00 | Mon - Fri
      </div>
    </div>
    <div class="tabbar">
      <el-link class="footerSizeStyle" @click="toProblem()">常见问题</el-link
      ><span>|</span>
      <el-link class="footerSizeStyle" @click="toJoin()">成为分销商</el-link>
      <span>|</span>
      <el-link class="footerSizeStyle" @click="toRecruit()">招聘信息</el-link>
      <span>|</span>
      <el-link class="footerSizeStyle" @click="toClause()">条款细则</el-link>
      <span>|</span>
      <el-link class="footerSizeStyle" @click="toPrivacy()"
        >隐私保护政策</el-link
      >
      <span>|</span>
      <!--            <el-link class="footerSizeStyle" disabled>负责声明</el-link>-->
      <!--            <span>|</span>-->
      <el-link class="footerSizeStyle" @click="toMap()">网站地图</el-link>
      <span>|</span>
      <el-link class="footerSizeStyle" @click="toRecord()">
        <div class="box1">
          <div class="webBox">
            <img src="../assets/images/Aadd.png" alt="" style="" />
          </div>
          <div class="webText" >其他品牌滤网</div>
             <div class="webBox1">
              <img src="../assets/jiantou.gif" alt="" />
            </div>
        </div>
      </el-link>
    </div>

    <!-- 横线 -->
    <div class="footer_line"></div>
    <!-- 备案信息 -->
    <div class="record">
      <a style="margin-right: 100px;color: #525252;" href="https://beian.miit.gov.cn/" target="_blank"
        >沪ICP备10207163号</a
      >

      <span>© RENAUD AIR LIMITED 2022 版权所有。</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    // 常见问题跳转
    toProblem() {
      // this.$message.info('暂未开放，敬请期待',1);
      // return
      this.$router.push({
        path: "/faq",
      });
    },
    // 跳转Air
    toAir() {
      this.$router.push({
        path: "/air",
      });
    },
    // 跳转Care
    toCare() {
      this.$router.push({
        path: "/care",
      });
    },
    // 跳转订阅我们
    toSubscribe() {
      this.$router.push({
        path: "/subscribe",
      });
    },
    // 跳转企业资讯
    toInfor() {
      this.$router.push({
        path: "/news",
      });
    },
    // 跳转2D体验馆
    toExper() {
      // this.$message.warning('即将上线，敬请期待！',1);

      this.$router.push({
        path: "/experience",
      });
    },
    // 跳转预约空气检测
    toDete() {
      this.$router.push({
        path: "/airtest",
      });
    },
    // 跳转关于我们
    toAbout() {
      this.$router.push({
        path: "/about",
      });
    },
    // 跳转加入我们
    toJoin() {
      this.$router.push({
        path: "/join",
      });
    },
    // 跳转条款细则
    toClause() {
      this.$router.push({
        path: "/clause",
      });
    },
    // 跳转隐私保护政策
    toPrivacy() {
      this.$router.push({
        path: "/privacy",
      });
    },
    // recruit跳转到招聘信息
    toRecruit() {
      this.$router.push({
        path: "/recruit",
      });
    },
    toMap() {
      this.$router.push({
        path: "/websiteMap",
      });
    },
    beian() {
      window.open("https://beian.miit.gov.cn/", "_blank");
    },
    toRecord() {
      window.open("http://www.medicfilter.com.cn/", "_blank");
    },

    //  微信二维码
    // wechat(){
    //     this.$success({
    //         title: '打开微信扫一扫',
    //         content: (
    //         <div>

    //         </div>
    //         ),
    //     });
    // },
  },
};
</script>

<style lang="less" scoped>
/* ------------------------------ 底部栏 ----------------------------- */
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
  // 屏幕小于960px
  // 导航组
    .box1 {
    display: flex;
    align-items: center;
	padding-top: 20px;

  }
  .webBox {
    width: 60px;
    display: flex;
    align-items: center;
    // margin-top: -6px;
    img {
      width: 100%;
    }
  }
     .webBox1 {
    width: 0.582292rem;
    display: flex;
    align-items: center;
    img {
      width: 100%;
    }
  }
   .webText{
	  padding-left: 20px;
     padding-left: 8px; 
   letter-spacing: 0px;
    font-weight: 600;
    color: #008000c4;
  }
  .nav_block {
    display: none;
  }

  // 导航栏
  .tabbar {
    margin-top: 4%;
	display: flex;
    flex-wrap: wrap;

    .footerSizeStyle {
      font-size: 40px;
    }

    span {
      font-size: 38px;
    }
  }

  // 备案信息
  .record {
    font-size: 40px;
  }
  .bottom {
    width: 100%;
    margin: auto;
    font-size: 45px;
    text-align: center;
    line-height: 80px;
    margin-top: 5%;
  }
}

// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
  // 屏幕大于960px
  // 导航组
  .box1 {
    display: flex;
    align-items: center;
  }
  .webBox {
   width: 0.110208rem;
    margin-top: -6px;
    img {
      width: 100%;
    }
  }
     .webBox1 {
    width: 30px;
    display: flex;
    align-items: center;
    img {
      width: 100%;
    }
  }

  .webText{
	 padding-left: 8px; 
   letter-spacing: 0px;
    font-weight: 600;
    color: #008000c4;
  }
  .nav_block {
    display: block;
  }
  .bottom {
    display: none;
  }
  // 导航栏
  .tabbar {
    .footerSizeStyle {
      font-size: 18px;
    }

    span {
      font-size: 16px;
    }
  }

  // 备案信息
  .record {
    font-size: 20px;
  }
}

.wechat_code {
  width: 200px;
}

.footer {
  width: 100%;
  background-color: #fff;

  // 导航组
  .navigation {
    width: 75%;
    display: flex;
    justify-content: space-around;
    padding: 66px 0 70px 0;
    margin: 0 auto;

    // 主标题样式
    .brand_title {
      width: 150px;
    }

    // 品牌故事
    .brand {
      text-align: center;
      font-size: 18px;
      color: #525252;
      letter-spacing: 4px;

      p {
        margin: 0;
        border-bottom: 1px dashed #525252;
        padding: 0 2px 0 6px;
        margin: 0 auto;
        margin-bottom: 10px;
        line-height: 1.5;
        cursor: pointer;
      }

      div {
        width: 60%;
        margin: 0 auto;
        // border-bottom: 1px dashed #525252;
        margin-bottom: 10px;
      }

      // 2D体验馆
      span {
        display: block;
        letter-spacing: normal;
        padding: 5px 0 3px 0;
      }
    }

    // 关注我们
    .focus {
      font-size: 18px;
      color: #525252;

      p {
        margin: 0;
        letter-spacing: 4px;
        text-align: center;
      }

      // 图标组
      .focus_box {
        display: flex;
        margin-top: 20px;

        img {
          width: 37px;
          height: 37px;
        }
      }
    }

    // 支付方式
    .play {
      font-size: 18px;
      color: #525252;

      p {
        margin: 0;
        letter-spacing: 6px;
        text-align: center;
      }

      // 图标组
      .play_box {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;

        img {
          width: 37px;
          height: 37px;
        }

        .play_card {
          width: 43px;
          height: 27px;
          margin-top: 5px;
        }
      }
    }
  }

  // 导航栏
  .tabbar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .footerSizeStyle {
      color: #525252;
      letter-spacing: 4px;
      margin: 0;
    }

    span {
      margin: 0px 30px 0 23px;
    }
  }

  // 横线
  .footer_line {
    width: 75%;
    border-bottom: 2px solid #dadada;
    margin: 0 auto;
    margin-top: 30px;
  }

  // 备案信息
  .record {
    color: #525252;
    text-align: center;
    padding: 30px 0 60px 0;
  }
}

// 条款明细
.terms_of {
  color: #8c8c8c;
  font-size: 18px;

  div {
    line-height: 30px;
  }

  b {
    color: black;
    display: inline-block;
    margin-bottom: 5px;

    &:first-child {
      margin-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue